import { Select, SelectItem } from '@utima/ui';

import { useLanguage } from '@/hooks/useLanguage';
import { supportedUILocales } from '@/locale/i18n';

export function LanguageSwitcher() {
  const { setLanguage, language } = useLanguage();

  return (
    <div className='w-20'>
      <Select
        value={language}
        onValueChange={value => {
          setLanguage(value);
        }}
      >
        {supportedUILocales.map(lang => (
          <SelectItem key={lang} value={lang}>
            {lang.toUpperCase()}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}
